export type GoogleTagManagerProps = {
    tagId: string /** GTM ID. */
    nonce?: string /** In case of using CSP header. */
    environment?: {
        auth: string /** Environment based: gtm_auth. */
        preview: string /** Environment based: gtm_preview. */
    }
}

function getEnvironmentQueryParameters(auth: string, preview: string) {
    return `&gtm_auth=${auth}&gtm_preview=${preview}&gtm_cookies_win=x`
}

/**
 * Inserts the Google Tag Manager script. To be embedded in the page `<head>`.
 */
export function GoogleTagManager({ tagId, nonce, environment }: GoogleTagManagerProps) {
    if (!tagId) return null

    const envQuery = environment
        ? getEnvironmentQueryParameters(environment.auth, environment.preview)
        : ''

    const script = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl+'${envQuery}';f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${tagId}');`

    return (
        <>
            <link rel="preconnect" href="https://stats.g.doubleclick.net" />
            <link rel="preconnect" href="https://www.google.com" />
            <link rel="preconnect" href="https://www.google-analytics.com" />
            <link rel="preconnect" href="https://www.googletagmanager.com" />
            {/* biome-ignore lint/security/noDangerouslySetInnerHtml: ignored for now, but this component should be removed */}
            <script nonce={nonce} dangerouslySetInnerHTML={{ __html: script }} />
        </>
    )
}

export function GoogleTagManagerNoScript({ tagId, environment }: GoogleTagManagerProps) {
    const envQuery = environment
        ? getEnvironmentQueryParameters(environment.auth, environment.preview)
        : ''

    return (
        <noscript
            // biome-ignore lint/security/noDangerouslySetInnerHtml: ignored for now, but this component should be removed
            dangerouslySetInnerHTML={{
                __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${tagId}${envQuery}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
            }}
        />
    )
}
